enum WhitelabelDomainStatus {
  Pending = 'pending',
  AwaitingDnsResponse = 'awaiting_dns_response',
  VerifyingCustomDomain = 'verifying_custom_domain',
  Success = 'success',
  FailedWithTimeout = 'failed_with_timeout',
  Failed = 'failed',
}

export default WhitelabelDomainStatus;
